import { useQuery } from '@tanstack/react-query'
import { profile, isEmpty } from '@myap/ui-library'
import { getRequest, queryIsEnabled } from '../utils/fetchOperations'
import { EDUCATION_PERIODS_KEY } from '../components/_common/reactquery'

// If user has a studentId, fetch from standard paapro endpoint, otherwise use referencedata

const useEducationPeriodsQuery = ({ id, myDetailsComplete }) => {
  const { apiUrl } = profile()
  const hasId = !isEmpty(id)
  return useQuery({
    queryKey: hasId ? [EDUCATION_PERIODS_KEY, id] : [EDUCATION_PERIODS_KEY],
    enabled: queryIsEnabled(myDetailsComplete),
    staleTime: 3600000,
    refetchOnWindowFocus: false,
    // initialData: { educationPeriods: [], currentEducationPeriod: {} },
    queryFn: async ({ signal }) => {
      const educationPeriodsData = await getRequest({
        url: hasId
          ? `${apiUrl}/paapro/v1/student/${id}/education-periods`
          : `${apiUrl}/paapro/v1/referencedata/education-periods/current`,
        signal,
      })
      const educationPeriods = hasId
        ? educationPeriodsData
        : [{ ...educationPeriodsData, hasEnrollments: false, isRegistered: false }]
      // educationPeriods can be null when user is Unknown professional
      const currentEducationPeriod =
        educationPeriods !== null
          ? educationPeriods?.length === 1
            ? educationPeriods[0]
            : educationPeriods.find(edpd => edpd.chronology === 'current')
          : {}
      return { educationPeriods, currentEducationPeriod }
    },
  })
}

export default useEducationPeriodsQuery
